import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ErrorPage = React.memo(() => {
  const { state } = useLocation();

  const error = state?.error;
  const hasError = !!error && error !== 'undefined';

  useEffect(() => {
    document.title = 'Erreur de connexion - FranceConnect';
  }, []);

  const errorContent = {
    pageNotFound: {
      message: 'La page que vous recherchez n’existe pas ou a été déplacée.',
      title: '404 Page introuvable',
    },
    unknownErrorCode: {
      message:
        'Nous vous invitons à fermer tous les onglets de votre navigateur et à vous authentifier via FranceConnect en suivant les étapes de connexion.',
      title: `Aucun formulaire n’est associé au code d’erreur technique (${error})`,
    },
  };
  const content = hasError ? errorContent.unknownErrorCode : errorContent.pageNotFound;

  return (
    <div className="fr-alert fr-alert--error">
      <h1 className="fr-alert__title fr-h3" data-testid="error-title">
        {content.title}
      </h1>
      <p data-testid="error-description">{content.message}</p>
    </div>
  );
});

ErrorPage.displayName = 'ErrorPage';
